// List of complaint types for Product Complaints
export const PRODUCT_COMPLAINT_TYPES = [
  'Alignment issue',
  'Batch Variation',
  'Bent',
  'Broken',
  'Chipped',
  'Cracks',
  'Cushion sagging',
  'Detached',
  'Fading',
  'Frame issue',
  'Installation manual missing',
  'Leaking',
  'Manufacturing/Supplier Issue',
  'Mattress Issue',
  'Mechanism Issue',
  'Moist in the Item',
  'Noise issue',
  'Packaging Issue',
  'Part Missing',
  'Peeling',
  'Rusting',
  'Scratches',
  'Shaking',
  'Smell',
  'Spring issue',
  'Stain',
  'Tear',
  'Pilling (Fabric issue)',
  'Wrong Color Inside Box',
  'Wrong Parts Inside Box',
  'Wrong size in box',
  'Damage During Transportation',
  'Delayed Delivery',
  'Delayed Delivery of display pc at WH',
  'Delivery not scheduled',
  'Display piece damaged',
  'Fixing Pending',
  'Incomplete information during purchase',
  'Incorrect Order details',
  'Installation Issue',
  'Not infofmed display piece',
  'Pick Up delayed',
  'Property Damage',
  'Wrong Commitment',
  'Wrong Display',
  'Wrong Interaction',
  'Wrong order/item/delivered punched',
  'Incorrect Dimensions',
];

// Product complaint groups shown in the Type dropdown
export const PRODUCT_COMPLAINT_CATEGORIES = [
  { value: 'missing_incorrect_components', label: 'Missing / Incorrect Components' },
  { value: 'packaging_handling_issues', label: 'Packaging & Handling Issues' },
  { value: 'physical_damage', label: 'Physical Damage' },
  { value: 'quality_manufacturing_issues', label: 'Quality / Manufacturing Issues' },
];


// Delivery complaint groups shown in the Type dropdown
export const DELIVERY_COMPLAINT_CATEGORIES = [
  { value: 'delivery_delay', label: 'Delayed Delivery' },
  { value: 'damage_incorrect_delivery', label: 'Damage / Incorrect Delivery' },
  { value: 'delivery_experience_staff_conduct', label: 'Delivery Staff Behavior' },
];

export const SERVICE_REQUEST_TYPES = [
  'Water Purifier',
];

export const DELIVERY_COMPLAINT_TYPES = [
  'Delayed Delivery',
  'Installation Issue',
  'Others',
  'Partial Delivery',
];

export const SERVICE_REQUEST_WATER_PURIFIER = [
  'Filter Change',
  'Water Leakage',
  'Installation',
  'Re-Installation',
  'AMC',
  'Others',
];

export const COMPLAINT_DELIVERY_DELAY_SUB_TYPES = [
  'Delay in Express Delivery',
  'Partially Delivered',
  'Delayed Delivery',
  'Others',
];

export const COMPLAINT_INSTALLATION_ISSUE_SUB_TYPES = [
  'Parts Missing',
  'Alignment / Shaking issue',
  'Incomplete fixing',
  'Noise issue',
  'High installation time',
  'Hardware missing',
  'Manufacturing Defect',
  'Wrong Item Received',
  'Others',
];

export const COMPLAINT_DELIVERY_OTHERS_SUB_TYPES = [
  'Staff is not trained',
  'No enough Staff',
  'Staff Attitude',
  'Others',
];
